import { IFormHandler } from "./forms";
import { IUserProfile } from "../config/settings";
import { Currency } from "../config/currencies";

export interface IProfileForm {
    default_currency: string;
    default_payment_method_id: string;
    default_language: string;
}

export class ProfileForm implements IFormHandler<IProfileForm, IUserProfile> {
    public readonly initialValue: IProfileForm;

    constructor(data?: IUserProfile) {
        this.initialValue = this.toForm(data);
    }

    toForm(data?: IUserProfile): IProfileForm {
        if (!data) {
            return {
                default_currency: '',
                default_payment_method_id: '',
                default_language: '',
            };
        }

        return {
            default_currency: data.default_currency,
            default_payment_method_id: data.default_payment_method_id?.toString() || '',
            default_language: data.default_language,
        };
    }

    toRequest(data: IProfileForm): IUserProfile {
        return {
            default_currency: data.default_currency as Currency,
            default_payment_method_id: data.default_payment_method_id !== '' ? parseInt(data.default_payment_method_id) : null,
            default_language: data.default_language,
        };
    }
}
